<template lang="pug">
div.contioner
  .fail-network(v-if="showErr")
    .header
      common-header.errorHeader(
        v-if="env.isEasyBikeApp"
        title=""
        activeTitle=""
        inactive-color="black"
      )
    .error-page
      img.pic(:src="errorPage")
      .tip {{errorTip}}
      .refresh(@click="getBasic") 重新加载
</template>
<script>
import CommonHeader from '@/components/common-middle-header';
import { getUserVipStatusV2 } from '@/api/vip';
import { env, Native } from '@hb/hbridge';
import h5Login from '@hb/h5-login';
import config from '@/const/config';
import { ParamsUtil } from '../../../utils/params';
import { getSource, getTokenAndKey } from '../../../utils';
import { getSystemCode } from '../../../utils/systemCode';

export default {
  components: {
    CommonHeader,
  },
  data() {
    return {
      urlObj: {},
      errorPage: 'https://m.hellobike.com/resource/helloyun/18536/T8xAzPwocM.png',
      errorTip: '当前网络不给力，请检查网络连接',
      showErr: false,
      env,
    };
  },
  async created() {
    h5Login.initConfig({
      env: config.env,
      systemCode: 'ZY001',
      debug: config.env !== 'pro',
    });
    // window.TianQiApm.APM.log({
    //   key: 'wechat_h5login_start',
    //   value: `${this.value}`,
    // });
    // 只需执行一次
    try {
      const handleVisibilityChange = async () => {
        if (document.visibilityState === 'visible') {
          try {
            const { token } = await getTokenAndKey({ force: true });
            this.isLogin = !!token;
            if (this.isLogin) {
              this.getBasic();
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error getting token:', error);
          }
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      // 清除用户本地缓存的改动getTokenAndKey的classMethod;
      const { token } = await getTokenAndKey({ force: true }) || {};
      this.isLogin = !!token;
      // eslint-disable-next-line no-empty
    } catch (e) {
    }
    this.urlObj = ParamsUtil.getParams(window.location.href);
  },
  async mounted() {
    const isLogin = await Native.isLogin();
    if (!isLogin && env.isEasyBikeApp) {
      await getTokenAndKey();
      return;
    }
    if (!isLogin && !env.isEasyBikeApp) {
      this.init();
    }
    if (isLogin) {
      this.getBasic();
    }
  },
  methods: {
    async getBasic() {
      const { token } = await getTokenAndKey();
      let link = await getUserVipStatusV2({
        token,
        systemCode: getSystemCode(),
      })
        .then((res) => {
          if (res && res.data && res.data.jumpUrl) {
            return res.data.jumpUrl;
          }
          return null;
        })
        .catch(() => null);
      if (link) {
        const adsource = getSource();
        if (adsource) {
          link = ParamsUtil.removeParams(link, 'adsource');
          link = ParamsUtil.addParams(link, { adsource });
        }
        link = ParamsUtil.addParams(link, { ...this.urlObj });
        window.location.replace(link);
      } else {
        this.showErr = true;
      }
    },

    init() {
      h5Login
        .signIn()
        .then(async (res) => {
          let link = await getUserVipStatusV2({
            token: res.token,
            systemCode: getSystemCode(),
          })
            .then((value) => {
              if (value && value.data && value.data.jumpUrl) {
                return value.data.jumpUrl;
              }
              return null;
            })
            .catch(() => null);
          if (link) {
            const adsource = getSource();
            if (adsource) {
              link = ParamsUtil.removeParams(link, 'adsource');
              link = ParamsUtil.addParams(link, { adsource });
            }
            window.location.href = ParamsUtil.addParams(link, {
              token: res.token,
              ticket: res.ticket,
              mobile: res.mobile,
              citycode: '310100',
              adcode: '021',
            });
          } else {
            this.showErr = true;
          }
        })
        .catch(() => {
          // window.TianQiApm.APM.log({
          //   key: 'wechat_h5login_failed',
          //   value: `${this.value}`,
          // });
        });
    },
  },
  // init() {
  //   h5Login
  //     .signIn()
  //     .then(async (res) => {
  //       let link = await getUserVipStatusV2({
  //         token: res.token,
  //         systemCode: getSystemCode(),
  //       })
  //         .then((value) => {
  //           if (value && value.data && value.data.jumpUrl) {
  //             return value.data.jumpUrl;
  //           }
  //           return null;
  //         })
  //         .catch(() => null);
  //       if (link) {
  //         const adsource = getSource();
  //         if (adsource) {
  //           link = ParamsUtil.removeParams(link, 'adsource');
  //           link = ParamsUtil.addParams(link, { adsource });
  //         }
  //       }

  //       window.location.href = ParamsUtil.addParams(link, {
  //         token: res.token,
  //         ticket: res.ticket,
  //         mobile: res.mobile,
  //         citycode: '310100',
  //         adcode: '021',
  //       });
  //     })
  //     .catch(() => {
  //       // window.TianQiApm.APM.log({
  //       //   key: 'wechat_h5login_failed',
  //       //   value: `${this.value}`,
  //       // });
  //     });
  // },
};
</script>
<style lang="less" scoped>
div.contioner {
  .fail-network {
    width: 100vw;
    height: 100vh;
    background: #fff;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;

    .error-page {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .pic {
        width: 1.3rem;
        height: 1.36rem;
      }

      .tip {
        margin-top: 0.16rem;
        font-size: 0.16rem;
        font-weight: 400;
        color: #bcc4cc;
      }

      .refresh {
        width: 1rem;
        height: 0.4rem;
        margin-top: 0.2rem;
        line-height: 0.4rem;
        text-align: center;
        background: #08f;
        border-radius: 0.08rem;
        font-size: 0.16rem;
        font-weight: 500;
        color: #fff;
      }
    }
  }
}
</style>
